(function () {
  function normalize(str) {
    return (str || "")
      .toString()
      .trim()
      .toLowerCase();
  }

  function getSelectedColor() {
    // 1) Standard Shopify option input: options[Color]
    const colorInput =
      document.querySelector('[name="options[Color]"]:checked') ||
      document.querySelector('[name="options[Color]"]');

    if (colorInput) return normalize(colorInput.value);

    // 2) Some themes use select elements for options
    const colorSelect = document.querySelector('select[name="options[Color]"]');
    if (colorSelect) return normalize(colorSelect.value);

    // 3) Fallback: read from any element that stores current variant options
    // (Best-effort, may not exist in all themes)
    const anyOption = document.querySelector('[name^="options["]:checked') || document.querySelector('[name^="options["]');
    return anyOption ? normalize(anyOption.value) : "";
  }

  function getAllMediaNodes() {
    // Try common Shopify media selectors (covers many OS2 themes)
    const selectors = [
      '[data-media-id]',                 // common on media items
      '.product__media-item',            // some themes
      '.product-media__item',            // some themes
      '.media-gallery__item',            // some themes
      '.swiper-slide',                   // if slider uses Swiper
    ];

    // Collect unique nodes
    const nodes = new Set();
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((n) => nodes.add(n));
    });

    return Array.from(nodes);
  }

  function getAltTextForNode(node) {
    // Try to find the image inside the media node
    const img =
      node.querySelector("img") ||
      node.querySelector("picture img") ||
      node.querySelector("source") ||
      null;

    if (img && img.getAttribute) {
      return img.getAttribute("alt") || "";
    }

    // Sometimes alt is stored on a nested media element
    const altEl = node.querySelector("[alt]");
    return altEl ? altEl.getAttribute("alt") || "" : "";
  }

  function filterImagesByColor(colorValue) {
    const color = normalize(colorValue);
    if (!color) return;

    const mediaNodes = getAllMediaNodes();
    if (!mediaNodes.length) return;

    let anyShown = false;

    mediaNodes.forEach((node) => {
      const alt = normalize(getAltTextForNode(node));

      // We match: "color: <value>"
      const shouldShow = alt.includes("color:") && alt.includes(`color: ${color}`);

      // If no alt label exists, we hide it to enforce strict filtering
      if (shouldShow) {
        node.style.display = "";
        node.style.visibility = "";
        anyShown = true;
      } else if (alt.includes("color:")) {
        node.style.display = "none";
      }
    });

    // If nothing matched (wrong ALT), do nothing (avoid blank gallery)
    if (!anyShown) {
      console.warn("[Variant Image Filter] No images matched for color:", color);
    }
  }

  function onVariantChange() {
    const selectedColor = getSelectedColor();
    filterImagesByColor(selectedColor);
  }

  function init() {
    // Run once on load
    onVariantChange();

    // Listen to option changes
    document.addEventListener("change", (e) => {
      const target = e.target;
      if (!target) return;

      // If any option changes, re-check color
      if (target.name && target.name.includes("options[")) {
        onVariantChange();
      }
    });

    // Some themes dispatch custom variant events (best effort)
    document.addEventListener("variant:change", onVariantChange);
    document.addEventListener("product:variant-change", onVariantChange);
  }

  // Delay a bit to ensure gallery/slider is rendered
  window.addEventListener("load", () => {
    setTimeout(init, 300);
  });
})();